import {cva} from "class-variance-authority";
import {Slot} from "@radix-ui/react-slot";
import {cn} from "@/lib/utils.js";
import * as React from "react";
import {buttonVariants} from "@/components/ui/button.jsx";

const headingVariants = cva('font-medium text-black/90 text-xl', {
  variants: {
    variant: {
      highlight: 'pb-2 relative after:content-[\'\'] after:absolute after:h-1/2 after:xl:h-1/3  after:-inset-x-2 after:top-1/2 after:bg-brand-red/20',
      dash: 'relative after:content-[\'\'] after:absolute after:h-2 after:xl:h-2  after:left-1/2 after:-ml-12 after:w-24 after:-top-4 after:bg-brand-red'

    },

    size: {
      'h1': 'text-5xl',
      'h2': 'text-4xl',
      'h3': 'text-3xl',
      'h4': 'text-2xl',
      'h5': 'text-xl',
      'h6': 'text-lg',
    },
  },
  defaultVariants: {
    size: 'h2'
  }
})

function Heading({
                   className,
                   size,
                   variant,
                   as = 'h2',
                   asChild = false,
                   ...props
                 }) {
  const Comp = asChild ? Slot : as

  return (
    <Comp
      data-slot="heading"
      className={cn(headingVariants({size, variant, className}))}
      {...props} />
  );
}

export {Heading, headingVariants}